import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from '@/components/HelloWorld'
import Overview from "@/components/Overview";
import Detail from "@/components/Detail";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE,
  routes: [
    {
      path: "/",
      name: "Overview",
      component: Overview,
    },
    {
      path: "/meldingen",
      name: "Notifications",
      component: Overview,
    },
    {
      path: "/veren/:slug",
      name: "Detail",
      component: Detail,
    },
  ],
});
